import { Region } from '@paragon/contract-library';

import { SealingService } from '../connections';

export function fetch() {
  return SealingService.get<readonly Region[]>('regions');
}
